import { render, staticRenderFns } from "./Flist.vue?vue&type=template&id=f4ecda18&scoped=true&"
import script from "./Flist.vue?vue&type=script&lang=js&"
export * from "./Flist.vue?vue&type=script&lang=js&"
import style0 from "./Flist.vue?vue&type=style&index=0&id=f4ecda18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ecda18",
  null
  
)

export default component.exports